import * as React from 'react'
import { match } from 'react-router';
import { RAQuestion } from '../../models';
import Question from './Question';
import questionData from './QuestionData';

interface RAQuestionnaireProps{
  match: match<{questionNo: string }>
}

export default (props: RAQuestionnaireProps) => {
  const questionNo: number = parseInt(props.match.params.questionNo, 10);
  const questionCount: number = questionData.questions.length;
  const currentQuestion: RAQuestion = questionData.questions[questionNo - 1];

  return (
    <div>
      {
        questionNo <= questionCount && (
          <div className='questionnaire'>
            <Question question={currentQuestion} questionNo={questionNo} />
          </div>
        )
      }
      {
        questionNo > questionCount && (
          <div>
            Thanks for taking the questionnaire
          </div>
        )
      }
    </div>
  )
}
